import LogOutConfirmation from '../ConfirmationDialog/LogOutConfirmation';
import { setLogin } from '../../store/app';
import { useState } from 'react';
export default function Hamburger() {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const handleDialog = () => {
    setOpenConfirmationDialog(true);
  };

  const logout = (issuccess) => {
    setOpenConfirmationDialog(false);
    window.location.reload();
    if (issuccess) {
      localStorage.setItem('monitor-user', '');
      window.location.reload();
      window.client?.store.dispatch(setLogin({ isLoggedin: false }));
    }
  };
  return (
    <div className="hamburger">
      <div className="hamburger-menu">
        <input id="menu__toggle" type="checkbox" />
        <label className="menu__btn" htmlFor="menu__toggle">
          <span></span>
        </label>

        <ul className="menu__box">
          <li>
            <a className="menu__item" href="/dashboard">
              Dashboard
            </a>
          </li>
          <li>
            <a className="menu__item" href="/dashboard/project">
              Projects
            </a>
          </li>
          <li>
            <a className="menu__item" href="/dashboard/notifications">
              Notifications
            </a>
          </li>
          <li>
            <a className="menu__item" href="/dashboard/userlistsettings">
              Users
            </a>
          </li>
          <li>
            <div className="menu__item">
              <div className="lowrow" onClick={() => handleDialog()}>
                {openConfirmationDialog ? <LogOutConfirmation closedialogs={logout} /> : <></>}
                Logout
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
